"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorMessage = require("../../__beta__/ErrorMessage/ErrorMessage");

var _ErrorMessage2 = _interopRequireDefault(_ErrorMessage);

var _Spinner = require("../../Spinner/Spinner");

var _Spinner2 = _interopRequireDefault(_Spinner);

var _LoadMore = require("../LoadMore/LoadMore");

var _LoadMore2 = _interopRequireDefault(_LoadMore);

var _SingleselectWithSections = require("../SingleselectWithSections/SingleselectWithSections");

var _SingleselectWithSections2 = _interopRequireDefault(_SingleselectWithSections);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LazySingleselectWithSections = function (_SingleselectWithSect) {
  _inherits(LazySingleselectWithSections, _SingleselectWithSect);

  function LazySingleselectWithSections() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LazySingleselectWithSections);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LazySingleselectWithSections.__proto__ || Object.getPrototypeOf(LazySingleselectWithSections)).call.apply(_ref, [this].concat(args))), _this), _this.itemMatchesFilter = function () {
      return true;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LazySingleselectWithSections, [{
    key: "renderLoadMoreButton",
    value: function renderLoadMoreButton() {
      if (this.props.allItemsLoaded) return null;

      return _react2.default.createElement(_LoadMore2.default, {
        isDisabled: this.props.isDisabled,
        loadMoreText: this.props.loadMoreText,
        onLoadMore: this.props.onLoadMore
      });
    }
  }, {
    key: "renderIsLoading",
    value: function renderIsLoading() {
      if (!this.props.isLoading) return null;

      return _react2.default.createElement(
        "div",
        { className: "aclui-multiselect--is-loading" },
        _react2.default.createElement(_Spinner2.default, { size: "small" })
      );
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      if (!this.state.isExpanded) return null;

      var body = void 0;

      if (this.props.errorMessage) {
        body = _react2.default.createElement(
          _ErrorMessage2.default,
          { style: this.getHeightStyle() },
          this.props.errorMessage
        );
      } else {
        var error = void 0;

        if (this.state.showInlineError) {
          error = _react2.default.createElement(
            _ErrorMessage2.default,
            { style: this.getHeightStyle() },
            this.props.invalidInputErrorMessage
          );
        }

        body = _react2.default.createElement(
          "span",
          null,
          this.renderFilterField(),
          error,
          _react2.default.createElement(
            "div",
            { className: "aclui-multiselect__scrolling-area", role: "listbox", style: this.getHeightStyle() },
            this.renderItemsAndDividers(),
            this.renderLoadMoreButton()
          ),
          this.renderIsLoading()
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "aclui-multiselect__body" },
        body
      );
    }
  }]);

  return LazySingleselectWithSections;
}(_SingleselectWithSections2.default);

LazySingleselectWithSections.propTypes = _extends({}, _SingleselectWithSections2.default.propTypes, {

  /** Has all the items loaded during lazy loading. */
  allItemsLoaded: _propTypes2.default.bool,

  /** If the component needs to indicate things are loading. */
  isLoading: _propTypes2.default.bool,

  /** Text of the button that lazy loads more items. */
  loadMoreText: _propTypes2.default.string.isRequired,

  /** Function to call when more items needed. */
  onLoadMore: _propTypes2.default.func.isRequired
});

LazySingleselectWithSections.defaultProps = _extends({}, _SingleselectWithSections2.default.defaultProps, {
  allItemsLoaded: false,
  isLoading: false
});

exports.default = LazySingleselectWithSections;